import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkSettingView } from '../interfaces/link-setting-view.interface';

@Injectable({
	providedIn: 'root',
})
export class ApplicationSettingsService {
	private readonly url: string = 'Linksettings';

	constructor(private http: HttpClient) {}

	public get(LinkID: number): Observable<LinkSettingView[]> {
		let ownParams = new HttpParams();

		ownParams = ownParams.set('LinkID', LinkID.toString());

		return this.http.get<LinkSettingView[]>(this.url, { params: ownParams });
	}

	public editDescription(id: number, description: string) {
		return this.http.post(this.url + '/editDescription', { id, content: description });
	}

	public editTitle(id: number, title: string)
	{
		return this.http.post(this.url + '/editTitle', {id, content: title})
	}
}
